import { FacetFilter, Option } from "Models/FacetFilter/FacetFilter";
import * as $ from "jquery";
import Vue from 'vue';
import Component from "vue-class-component";
import ABaseComponent from "Components/Base/ABaseComponent";
import productList from "Store/productList/productList";
import { Prop } from "vue-property-decorator";
import { FilterItem } from "Models/FacetFilter/FilterItem";


@Component({})
export class FacetFilterComponent extends ABaseComponent{
    @Prop({required:true})
    facetFilters: FacetFilter[];

    get queryLoading() {
        return productList.state.isLoading;
    }

    created() {
    }

    SelectedOptions(facetFilter: FacetFilter): Option[] {
        return facetFilter.Options.filter(a => a.Selected);
    }

    ClearFilter(){
        productList.dispatchClearFilters();
    }
    
    ToggleFilter(facetName:string,option:Option) {
        let filterArray:FilterItem[] = new Array();
        filterArray.push(new FilterItem(facetName,option.Value));
        if(!option.Selected){
            productList.dispatchUpdateQueryRemoveValues(filterArray);
        }
        else{
            productList.dispatchUpdateQuery(filterArray);
        }
    }
}
Vue.component("facet-filter", FacetFilterComponent);